import BaseService from '@/services/services/tools/baseService';
import UserExchangesAPI from '@/services/api/internal/userexchanges.api';
import { treatsCurrent } from '@/business/apiTreatment/response/baseAPITreatment';
import LogbooksService from '@/services/services/logbooks.service';

const treatsItem = async (item) => {
  let treated = item;
  if (item.logbook_entry_id)
    await LogbooksService.getCurrent(item.logbook_entry_id).then((logbook) => {
      treated = {
        ...item,
        logbook,
      };
    });
  return {
    ...treatsCurrent({
      datetimeFieldNames: ['datetime'],
    })(treated),
  };
};
/**
 * Business function. Treats entries from API.
 * @param {object} response The response of the API
 * @returns {object} The response treated.
 */
const treatsUserExchanges = (response) => {
  const promises = response.data.items && response.data.items.map(treatsItem);
  return Promise.all(promises);
};
/**
 * Business function. Treats entry from API.
 * @param {object} response The response of the API
 * @returns {*&{logbook: (*|null)}} The response treated.
 */
const treatsUserExchange = (response) => {
  const entry = response.data.items[0];
  return treatsItem(entry);
};

const UserExchangesService = new BaseService({
  api: UserExchangesAPI,
  urlParamsItems: { expand: 'logbook' },
  treatListResponse: treatsUserExchanges,
  treatCurrentResponse: treatsUserExchange,
  treatCreateResponse: treatsUserExchange,
});

export default UserExchangesService;
